import React from 'react';
import { object, bool, func, string } from 'prop-types';
import { I18n, getContext } from '@fiverr-private/fiverr_context';
import { Icon } from '@fiverr-private/fit';
import { l_arrow_right } from '@fiverr-private/icons';
import { metric } from '@fiverr-private/perseus';
import { BQ_CLICKED_CONTACT_SELLER, BQ_SIGNUP_CLICK } from '../../../utils/bigQueryEvents';
import Trigger from '../../shared/FirstMessagePopup/Trigger';
import { MP_CLICKED_CONTACT_ME } from '../../../utils/mixPanelEvents';

import './style.scss';

const ContactSellerBtn = ({ showArrow, titleKey, onReportClick, onSubmitSuccess }, { biEvents }) => {
    const onClick = () => {
        const { userId } = getContext();

        if (!userId) {
            // The event BQ_SIGNUP_CLICK is reported here because we open the signUpModal manually
            // and not via the autoShowSignUp API

            biEvents.sendBigQueryEvent({ eventName: BQ_SIGNUP_CLICK });
            window.openSignUpModal();
        } else if (onReportClick) {
            onReportClick();
        } else {
            const sourceComponent = 'Gig page sticky';
            biEvents.sendMixPanelEvent({
                eventName: MP_CLICKED_CONTACT_ME,
                params: { 'Source component': sourceComponent }
            });

            const name = 'contact_seller';
            biEvents.sendBigQueryEvent({
                eventName: BQ_CLICKED_CONTACT_SELLER,
                params: { name }
            });

            metric.count('contact_seller.click');
        }

    };

    return (
        <div className="contact-seller-wrapper">
            <Trigger className="btn-contact-seller"
                onClick={onClick}
                onSubmitSuccess={onSubmitSuccess}>
                <I18n k={titleKey}/>
                {showArrow &&
                <Icon size={12}>{l_arrow_right}</Icon>
                }
            </Trigger>
        </div>
    );
};

ContactSellerBtn.propTypes = {
    showArrow: bool,
    titleKey: string,
    onReportClick: func,
    onSubmitSuccess: func
};

ContactSellerBtn.contextTypes = {
    biEvents: object
};

export default ContactSellerBtn;
